import React from 'react';

const TextError = (props) => {
    return (
        <div className='errorMessage' style={{color:"red",fontSize:"14px"}}>{props.children}</div>
    )
};

export default TextError;
